import _ from 'lodash';
import { createSelector } from 'reselect';
import { contentfulModels } from '@glowforge/ui-common';

const { interpretMetadata } = contentfulModels;

export const getStatesOptions = createSelector( // eslint-disable-line
  store => _.get(store, 'common.addressStates'),
  (countries) => {
    const stateOptions = {};
    _.forEach(countries, (country, key) => {
      if (!stateOptions[key]) { stateOptions[key] = []; }
      _.forEach(country.states, (state) => {
        stateOptions[key].push({
          label: state.name,
          value: state.id,
        });
      });
    });
    return stateOptions;
  },
);

export const getCountryOptions = createSelector( // eslint-disable-line
  store => _.get(store, 'common.addressCountries'),
  (countries) => {
    // Put the US as the first option
    const US = _.find(countries, { name: 'United States' });
    _.remove(countries, { name: 'United States' });
    countries.unshift(US);

    return (
      _.map(countries, country => ({
        label: country.name,
        value: country.id,
      }))
    );
  },
);

export const getUsCountryID = createSelector(
  store => _.get(store, 'common.addressCountries'),
  (countries) => {
    const US = _.find(countries, { name: 'United States' });
    return US.id;
  },
);

export const getUsCountryISO = createSelector(
  store => _.get(store, 'common.addressCountries'),
  (countries) => {
    const US = _.find(countries, { name: 'United States' });
    return US.iso;
  },
);

export const isIpAddressInUS = createSelector(
  store => _.get(store, 'common.country'),
  getUsCountryISO,
  (countryISO, usISO) => {
    return (countryISO === usISO) || !countryISO;
  },
);

export const getGlobalFooterContent = createSelector(
  store => _.get(store, 'common.footer'),
  footer => footer,
);

export const getProducts = state => _.get(state, 'glowforgeStore.products');

const getReferral = state => _.get(state, 'common.referral');
export const getReferralInfo = createSelector(
  getReferral,
  (referral) => {
    if (!referral || !referral.isReferral) return { showReferralInfo: false };
    const promoLink = (referral.pl) ? referral.pl.id : null;
    const referralCode = referral.code;
    return {
      referredByName: referral.referrerName,
      isAffiliate: referral.isAffiliate,
      photoUrl: referral.photoUrl,
      showReferralInfo: true,
      referralCode,
      promoLink,
    };
  },
);

export const getDefaultMetadata = createSelector(
  store => _.get(store, 'common.defaultMetadata'),
  metadata => interpretMetadata(metadata),
);



// WEBPACK FOOTER //
// ./app/common/selectors/common.js